import { FuseTranslationLoaderService } from "~app/services/translation-loader.service";
import { locale as english } from "./i18n/en";
import { locale as french } from "./i18n/fr";

import { NgModule } from "@angular/core";
@NgModule({
})
export class GuardsModule {
  constructor(translationLoader: FuseTranslationLoaderService) {
    translationLoader.loadTranslations(english, french);
  }
}
